import { Box } from '@mui/material';
import Cookies from 'js-cookie';

const CookiesOverlay = () => {
    const cookieYes = Cookies.get('cookieyes-consent');

    const showOverlay = !cookieYes?.includes('action:yes');

    return (
        <Box
            sx={{
                display: `${showOverlay ? 'block' : 'none'}`,
                background: '#000000',
                opacity: 0.4,
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                zIndex: 9999998,
            }}
        />
    );
};

export default CookiesOverlay;
